var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairHeadAttachments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.04,36.96h-6.41v-2.88h1.98c3.77,0,6.84-3.07,6.84-6.84v-9.84c0-3.77-3.07-6.84-6.84-6.84H21.85c-3.77,0-6.84,3.07-6.84,6.84v9.84c0,3.77,3.07,6.84,6.84,6.84h1.98v2.88h-7.45c-4.48,0-8.12,3.64-8.12,8.12v8.62c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-8.62c0-2.82,2.3-5.12,5.12-5.12h30.66c2.82,0,5.12,2.3,5.12,5.12v8.75c0,.83,.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-8.75c0-4.48-3.64-8.12-8.12-8.12Zm-.59-19.55v9.84c0,2.12-1.72,3.84-3.84,3.84h-1.98V13.57h1.98c2.12,0,3.84,1.72,3.84,3.84Zm-8.82,13.68h-10.8V13.57h10.8V31.09Zm-15.77,0c-2.12,0-3.84-1.72-3.84-3.84v-9.84c0-2.12,1.72-3.84,3.84-3.84h1.98V31.09h-1.98Zm4.98,3h10.8v2.88h-10.8v-2.88Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairHeadAttachments);
export default __webpack_public_path__ + "static/media/wheelchair_head_attachments.69d199d2.svg";
export { ForwardRef as ReactComponent };